import Button from '@/components/ui/Button'

import { Step } from '../hooks/usePmsSteps'

export function LinkComponent({ step }: { step: Step }) {
  if (!step.link) return null

  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-heading1 text-text">{step.title}</h1>
      {step.description && (
        <p className="text-regular text-text">{step.description}</p>
      )}
      <div className="p-4">
        <a href={step.link}>
          <Button className="w-full">{step.linkTitle}</Button>
        </a>
      </div>
    </div>
  )
}
